export default __webpack_public_path__ + "static/yt-poster-01_EN-3be26227b107e0fe27a1c85ba57f644d.jpg";